import { inject } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { ResolveFn } from "@angular/router";

export const metaResolver: ResolveFn<boolean> = (route, state) => {
	const metaService = inject(Meta);

	const { meta } = route.data;

	if (meta) {
		Object.entries<string>(meta).forEach(([name, content]) => {
			metaService.addTag({ name, content });
		});
	} else {
		metaService.addTag({
			name: "description",
			content: "Qcells is here for all of your solar needs!",
		});
	}

	return true;
};
